<app-auth-shell>
  @if (!verificationEmailSent) {
    <div class="auth_heading">
      <h1>Reset your password</h1>
      <p>Enter your username and we'll send you instructions to set a new password.</p>
    </div>

    <form [formGroup]="forgotPasswordLoginForm" (ngSubmit)="submitEmail()">
      <div class="input_with_label">
        <label for="username" class="required_field_label">Username</label>
        <input
          id="username"
          name="username"
          formControlName="username"
          type="text"
          placeholder="Enter your username"
          required
          autocomplete="username"
          [ngClass]="{
            form_error:
              forgotPasswordLoginForm.get('username')?.invalid &&
              forgotPasswordLoginForm.get('username')?.touched &&
              forgotPasswordLoginForm.get('username')?.errors
          }"
        />
        <div class="validation_error"
             *ngIf="forgotPasswordLoginForm.get('username')?.invalid && forgotPasswordLoginForm.get('username')?.touched">
          <small *ngIf="forgotPasswordLoginForm.get('username')?.errors?.['required']">Username is required</small>
        </div>
      </div>
      <button type="submit" class="primary_button auth_submit">Send reset instructions</button>
    </form>

    <a class="back_link" routerLink="/login"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3.5 5.5 8l4.5 4.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg> Back to sign in</a>
  } @else {
    <div class="auth_state">
      <app-status-illustration kind="mail-sent"></app-status-illustration>
      <div class="auth_heading">
        <h1>Reset instructions sent</h1>
        <p>{{ successMsg || "Check your email for a link to set a new password." }}</p>
      </div>
      <p class="access_help">Follow the link in the message to set a new password. You can close this tab.</p>
      <a class="back_link" routerLink="/login"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3.5 5.5 8l4.5 4.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg> Back to sign in</a>
    </div>
  }
</app-auth-shell>
